//WATER MAINTANCE PRODUCT DETAILS PAGE SUBSCRIPTION SELECTED BULK BUY OPTION JS START
var url = window.location.href;
var lastSegment = url.substring(url.lastIndexOf('/') + 1).split('?')[0].split('#')[0];
var productArr = ['water-maintenance-pack','chiller-maintenance-pack-bundle-bkp'];
if(productArr.includes(lastSegment)){
  var interId = setInterval(function(){
    if(jQuery('.custom_variant_box').find('#multibuy-input').length>0){
      //jQuery('.custom_variant_box').find('#onetime-input').trigger("click");
      setTimeout(function(){
        jQuery('.product-form__input').find('[value="Bulk Buy"]').trigger("click");
        jQuery('.custom_variant_box').find('#multibuy-input').trigger("click");
      },100);
      clearInterval(interId);
    }
  },1000);
  $('#subscribe-input').on('click', function () {
    $('label[data-option-value="single"]').click();
    $('label[for="rc-radio2"]').click();
    jQuery('.rc-radio-group__options').find('[value="subscription"]').trigger("click");
  });
}
//WATER MAINTANCE PRODUCT DETAILS PAGE SUBSCRIPTION SELECTED BULK BUY OPTION JS END

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open")
  );

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.lengthx - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary")
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);

      if (window.matchMedia("(max-width: 990px)")) {
        document.documentElement.style.setProperty(
          "--viewport-height",
          `${window.innerHeight}px`
        );
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach((submenu) => {
        submenu.classList.remove("submenu-open");
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    if (jQuery(this).closest(".landing-header").length != 1) {
      this.header =
        this.header || document.getElementById("shopify-section-header");
      this.borderOffset =
        this.borderOffset ||
        this.closest(".header-wrapper").classList.contains(
          "header-wrapper--border-bottom"
        )
          ? 1
          : 0;
    } else {
      this.header =
        this.header || document.getElementById("shopify-section-header");
      this.borderOffset =
        this.borderOffset ||
        this.closest(".header-wrapper").classList.contains(
          "header-wrapper--border-bottom"
        )
          ? 1
          : 0;
    }
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );

    const elementToApplyClass = document.querySelector(".sticky-add-to-cart");
    if (elementToApplyClass !== null) {
      elementToApplyClass.classList.add("sticky-close");
    }
    this.header.classList.add("menu-open");
    const pageBody = document.querySelector("body");
    pageBody.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    const pageBody = document.querySelector("body");
    pageBody.classList.remove("menu-open");
    this.header.classList.remove("menu-open");
  }
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.querySelector(".modal-container").appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
    
    
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
        this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0
    ) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
      )
    ) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    console.log("step ->>", step)
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    console.log("this.slideScrollPosition-->", this.slideScrollPosition);
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link")
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this))
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener(
      "click",
      this.autoPlayToggle.bind(this)
    );
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      "slider-counter__link--active"
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft +
          this.slider.querySelector(".slideshow__slide").clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll("a");
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute("tabindex");
          });
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute("tabindex", "-1");
          });
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
    this.initializeChillerOptionDeselect();
  }

  initializeChillerOptionDeselect() {
    // Ensure the DOM is fully loaded before querying elements
    document.addEventListener("DOMContentLoaded", () => {
      this.chillerOptionDeselect = document.querySelector(
        ".variantChiller__option[data-option-value=No]"
      );
      if (this.chillerOptionDeselect) {
        this.chillerOptionDeselect.addEventListener("click", () => {
          // Get the associated radio button
          const radio = document.querySelector(
            ".variantChiller__optionsInput-wrapper input[value=No]"
          );
          if (radio) {
            radio.checked = true;
            // Trigger the change event on the radio button to notify any listeners
            this.dispatchEvent(new Event("change"));
          }
        });
      }
    });
  }

  onVariantChange(evt) {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }

    // Split the string by '/' and process each part
    let splitStrings = this.currentVariant.title.split("/");
    let processedStrings = splitStrings.map((s) =>
      s.trim().toLowerCase().replace(/ /g, "-")
    );
    // Variable to track if any preorder value is found
    let foundPreOrderValue = false;
    const preOrderPropertyText = "properties[Pre-order]";
    let preorderValue;
    let preorderDisValue;
    // For each processed string, find matching elements
    processedStrings.forEach((processedString) => {
      // Find all elements with the class .variant-grid
      document.querySelectorAll(".variant-grid").forEach((variantGrid) => {
        // Find label elements inside .variant-grid that have a matching data-option-handle
        console.log("processedString==>", processedString)
        let matchingLabels = variantGrid.querySelectorAll(
          `label[data-option-value="${processedString}"]`
        );

        // Check if any matching label has the data-pre-order attribute and log its value
        matchingLabels.forEach((label) => {
          const preOrder = label.getAttribute("data-preorder");
          const preOrderDis = label.getAttribute("data-preorderdis");
          // console.log("preOrderDis--->", preOrderDis)
          // if (preOrderDis) {
          //   preorderDisValue = preOrderDis;
          //   foundPreOrderValue = true;
          // }
            
          if (preOrder) {
            preorderValue = preOrder;
            foundPreOrderValue = true;
          }
        });
      });
    });

    var variantobj = this.currentVariant;
    setTimeout(function () {
      if (jQuery(".landing-featured-product").length != 0) {
        var defualtmainPrice = variantobj.price;
        var mainPrice = Shopify.formatMoney(variantobj.price);
        var comparePrice = 0;
        var defaultcomparePrice = 0;
        if (variantobj.compare_at_price != undefined) {
          comparePrice = Shopify.formatMoney(variantobj.compare_at_price);
          defaultcomparePrice = variantobj.compare_at_price;
        }
        var percentageOff =
          ((defaultcomparePrice - defualtmainPrice) / defaultcomparePrice) *
          100;
        percentageOff = Math.round(percentageOff);
        jQuery(".landing-featured-product")
          .find(".price__container .price-item--regular")
          .text(comparePrice);
        jQuery(".landing-featured-product")
          .find(".price__container .price-item--sale")
          .text(mainPrice);
        jQuery(".landing-featured-product")
          .find(".price__container .price-save span")
          .text("save " + percentageOff + "%");

        jQuery("#variant__price").val(variantobj.price);
        jQuery(".landing-featured-product")
          .find(".btn_inside_price")
          .text(mainPrice);
      }
      else{

        const $selectedRadio = $('input[name="Select Chiller Type"]:checked');
        // Get the associated label element using `for` attribute
        const $label = $(`label[for="${$selectedRadio.attr('id')}"]`);
    
        // Get the compare price inside the label
        const $comparePriceElement = $label.find('.variant-price-compareAt');
        const comparePrice = $comparePriceElement.length ? $comparePriceElement.text().trim() : null;
      
        const $priceElement = $label.find('.variant-price-onSale');
        const mainPrice = $priceElement.length ? $priceElement.text().trim() : null;
    
        console.log("Selected radio button value:", $selectedRadio.val());
        console.log("Compare price:", comparePrice);

      jQuery(".variant-feature-list[data-option-value='no']").find(".variant-priceGroup")
          .find(".variant-price-onSale")
          .text(mainPrice);
        jQuery(".variant-feature-list[data-option-value='no']").find(".variant-priceGroup")
          .find(".variant-price-compareAt")
          .text(comparePrice);
        
        // var defualtmainPrice = variantobj.price;
        // var mainPrice = Shopify.formatMoney(variantobj.price);
        // var comparePrice = 0;
        // if (variantobj.compare_at_price != undefined) {
        //   comparePrice = Shopify.formatMoney(variantobj.compare_at_price);
        // }
        // jQuery(".variant-feature-list[data-option-value='no']").find(".variant-priceGroup")
        //   .find(".variant-price-onSale")
        //   .text(mainPrice);
        // jQuery(".variant-feature-list[data-option-value='no']").find(".variant-priceGroup")
        //   .find(".variant-price-compareAt")
        //   .text(comparePrice);
      }
    }, 800);
console.log("foundPreOrderValue-->", foundPreOrderValue)
    if (foundPreOrderValue) {
      document
        .querySelector(".preorder-line-item input")
        .setAttribute("name", preOrderPropertyText);
      document
        .querySelector(".preorder-line-item input")
        .setAttribute("value", preorderValue);
      document.querySelector(".preorder-message").style.display = "block";
      //document.querySelector(".metafield-rich_text_field").style.display = "none";
      jQuery(".preorder-message").find(".metafield-rich_text_field").hide();
      document.querySelector(".preorder-message--text").innerHTML = preorderValue;
      //document.querySelector(".preorder-message--text").innerHTML = preorderDisValue;
    } else {
      document
        .querySelector(".preorder-line-item input")
        .setAttribute("name", "");
      document
        .querySelector(".preorder-line-item input")
        .setAttribute("value", "");
      document.querySelector(".preorder-message").style.display = "none";
    }
    getselectedOption();
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(
      `[id^="MediaGallery-${this.dataset.section}"]`
    );
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(
        `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        true
      )
    );

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`
    );
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });

    // Get the id of the input element
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const sectionId = this.dataset.originalSection || this.dataset.section;
    const variantId = this.currentVariant.id;
    // Handle chiller selection class
    const variantOptionsWrapper = document.querySelectorAll(
      ".variant-options--select-model .variant-feature-list"
    );
    let chillerSelectedOverall = false;

    variantOptionsWrapper.forEach((el) => {
      const isChiller =
        this.currentVariant.title.includes("Pro Chiller") ||
        this.currentVariant.title.includes("Standard Chiller");

      // Determine if this specific el should have chillerSelected true or false
      const chillerSelected =
        isChiller && !el.classList.contains("chiller-bundle-option");

      // Set the data attribute for this el
      el.setAttribute(
        "data-chiller-selected",
        chillerSelected ? "true" : "false"
      );

      // If at least one el is selected as chiller, mark the overall state as true
      if (chillerSelected) {
        chillerSelectedOverall = true;
      }
    });
    /*
    // Now update the .badge--new element based on the overall chillerSelected state
    const badgeNewElement = document.querySelector(".badge--new");

    if (badgeNewElement) {
      badgeNewElement.textContent = chillerSelectedOverall ? "Free" : "New";
    }*/

    fetch(`${this.dataset.url}?variant=${variantId}&section_id=${sectionId}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");

        // Cache DOM lookups
        const source = html.getElementById(`price-${sectionId}`);
        const destination = document.getElementById(
          `price-${this.dataset.section}`
        );
        const stickyDestination = document.querySelector(
          ".sticky-atc-price-wrapper"
        );
        const stickyAtc = document.querySelector(".sticky-atc--selection");

        // Update price elements if they exist
        if (source && destination) destination.innerHTML = source.innerHTML;
        if (stickyDestination && source)
          stickyDestination.innerHTML = source.innerHTML;

        // Update sticky ATC text if exists
        if (stickyAtc) {
          const selectedVariantTitle = this.currentVariant.title
            .replace(/Yes add|\(280 watt\)|\(500 watt\)/g, "")
            .trim();
          stickyAtc.innerHTML = selectedVariantTitle;
        }

        // Remove hidden class from price element if it exists
        const price = document.getElementById(`price-${this.dataset.section}`);
        price?.classList.remove("visibility-hidden");

        // Update add to cart button
        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut
        );
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = "ADD TO CART";

    if (price) price.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();

    const checkedInput = document.querySelector(
      ".product-form__input input[name=Version]:checked"
    );
    const upsellProductWrapper = document.querySelector(
      ".upsellProductWrapper"
    );
    if (checkedInput) {
      if (checkedInput.value === "PRO Bundle") {
        upsellProductWrapper.style.display = "none";
        document.querySelector(".upsellATCCheckbox").checked = false;
      } else {
        upsellProductWrapper.style.display = "block";
      }
    } else {
      if (upsellProductWrapper) {
        upsellProductWrapper.style.display = "block";
      }
    }
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
    document.querySelectorAll("fieldset").forEach((fieldset) => {
      if (fieldset.classList.contains("variant__chiller-wrapper")) {
        const upsellProductWrapper = document.querySelector(
          ".upsellProductWrapper"
        );
        if (this.options.includes("PRO Bundle")) {
          upsellProductWrapper.style.display = "none";
          document.querySelector(".upsellATCCheckbox").checked = false;
        } else {
          if (
            document
              .querySelector(".chiller__optionSelected")
              .getAttribute("data-option-value") === "No"
          ) {
            document.querySelector(
              ".variantChiller__optionsInput-wrapper input[value=No]"
            ).checked = true;
            this.onVariantChange;
          }
          upsellProductWrapper.style.display = "block";
        }
      } else {
      }
    });
    const wrapperElement = document.querySelector(".variant-notice-wrapper");
    const variantNoticeMsg = document.querySelector(".variant-notice-msg");
    if (
      window.innerWidth < 460 &&
      !wrapperElement.classList.contains("notice-open")
    ) {
      wrapperElement.style.transition = "height 0.2s ease";
      wrapperElement.style.height = "40px";
      wrapperElement.classList.add("notice-open");

      variantNoticeMsg.style.transition = "opacity 0.4s ease";
      variantNoticeMsg.style.opacity = "1";

      setTimeout(() => {
        variantNoticeMsg.style.transition = "opacity 0.2s ease";
        variantNoticeMsg.style.opacity = "0";

        wrapperElement.style.transition = "height 0.4s ease";
        wrapperElement.style.height = "0";
        wrapperElement.classList.remove("notice-open");
      }, 8000);
    }
  }
}

customElements.define("variant-radios", VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (
            !this.querySelector("slideshow-component") &&
            this.classList.contains("complementary-products")
          ) {
            this.remove();
          }

          if (html.querySelector(".grid__item")) {
            this.classList.add("product-recommendations--loaded");
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("product-recommendations", ProductRecommendations);

// product review slider
new Swiper("[js-reviews-slider]", {
  slidesPerView: 1,
  spaceBetween: 16,
  grabCursor: true,
  loop: true,
  pagination: {
    el: ".slider__pagination",
    clickable: true,
  },
  autoplay: {
    delay: 4000,
  },
});

// product popup slider
new Swiper("[js-popup-img-slider]", {
  slidesPerView: 1,
  pagination: {
    el: ".slider__pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".next-btn",
    prevEl: ".prev-btn",
  },
});

// STICKY BTN

if (jQuery(".pdo_imgwith_text_section").length != 0) {
  jQuery(window).scroll(function () {
    var buttonHeight = parseInt(
      jQuery(".pdo_imgwith_text_section").offset().top
    );
    console.log("height", buttonHeight);
    console.log("scroll", jQuery(this).scrollTop());
    if (jQuery(this).scrollTop() > buttonHeight) {
      jQuery(".pdo-sticky-product-section").show();
    } else {
      jQuery(".pdo-sticky-product-section").hide();
    }
  });
}

//:: start :: logo marquee scripts :: ==================
$(".logo_marquee_slider").slick({
  slidesToShow: 8,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 0,
  speed: 4000,
  pauseOnHover: false,
  cssEase: "linear",
  responsive: [
    {
      breakpoint: 1240,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
  ],
});
//:: end :: logo marquee scripts :: ==================

//:: START :: image marquee scripts :: ==================
$(".image_marquee_slider").slick({
  slidesToShow: 5,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 0,
  speed: 8000,
  pauseOnHover: false,
  cssEase: "linear",
  arrows: false,
  dots: false,
  responsive: [
    {
      breakpoint: 1240,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
  ],
});
//:: END :: image marquee scripts :: ==================

//:: START :: TESTIMONIALS scripts :: ==================

$(".testimonials-slider").slick({
  infinite: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: false,
  dots: true,
  responsive: [
    {
      breakpoint: 991,
      settings: {
        arrows: false,
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 800,
      settings: {
        arrows: false,
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 600,
      settings: {
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
});

//:: END :: TESTIMONIALS scripts :: ==================

//:: START :: TABING FAQ :: ==================

document.addEventListener("DOMContentLoaded", function () {
  if ($(".tabing_faq_item_header").length) {
    const firstAccordionItemHeader = document.querySelector(
      ".tabing_faq_item_header"
    );
    const firstAccordionItemBody = firstAccordionItemHeader.nextElementSibling;

    // Open the first accordion item by default
    // firstAccordionItemHeader.classList.add("active");
    // firstAccordionItemBody.style.maxHeight =
    //   firstAccordionItemBody.scrollHeight + "px";

    const accordionItemHeaders = document.querySelectorAll(
      ".tabing_faq_item_header"
    );

    accordionItemHeaders.forEach((accordionItemHeader) => {
      accordionItemHeader.addEventListener("click", (event) => {
        const currentlyActiveAccordionItemHeader = document.querySelector(
          ".tabing_faq_item_header.active"
        );
        if (
          currentlyActiveAccordionItemHeader &&
          currentlyActiveAccordionItemHeader !== accordionItemHeader
        ) {
          currentlyActiveAccordionItemHeader.classList.toggle("active");
          currentlyActiveAccordionItemHeader.nextElementSibling.style.maxHeight = 0;
        }
        accordionItemHeader.classList.toggle("active");
        const accordionItemBody = accordionItemHeader.nextElementSibling;
        if (accordionItemHeader.classList.contains("active")) {
          accordionItemBody.style.maxHeight =
            accordionItemBody.scrollHeight + "px";
        } else {
          accordionItemBody.style.maxHeight = 0;
        }
      });
    });
  }
});

$(document).ready(function () {
  $("ul.tf_tabs li").click(function () {
    var tab_id = $(this).attr("data-tab");

    $("ul.tf_tabs li").removeClass("current");
    $(".tf_content").removeClass("current");

    $(this).addClass("current");
    $("." + tab_id).addClass("current");
  });
});

//:: END :: TABING FAQ :: ==================

//:: START :: LANDING BENEFITS :: ==================

$(document).ready(function () {
  $("ul.benefits_tabing li").click(function () {
    var tab_id = $(this).attr("data-tab");

    $("ul.benefits_tabing li").removeClass("current");
    $(".benefits_tab_content").removeClass("current");

    $(this).addClass("current");
    $("#" + tab_id).addClass("current");
  });
});

$(document).ready(function () {
  $(".landing_benefit_tabbing .lb-section-tabbing ul li").click(function () {
    var tab_id = $(this).attr("data-tab");
    console.log("ta ",tab_id);
    $(".landing_benefit_tabbing .lb-section-tabbing ul li").removeClass("current");
    $(".landing_benefit-text-tabbox").removeClass("current");

    $(this).addClass("current");
    if($("#" + tab_id).find('.benefits_tabing').find('.tab-link.current').length==0){
      $("#" + tab_id).find('.benefits_tabing').find('.tab-link').eq(0).addClass('current');
      $("#" + tab_id).find('.benefits_tab_content').eq(0).addClass('current');
    }
    $("#" + tab_id).addClass("current");
  });
});

//:: END :: LANDING BENEFITS :: ==================

// difference section

jQuery(document).ready(function () {
  jQuery("ul.new-tabs li").click(function () {
    var tab_id = jQuery(this).attr("data-tab");
    jQuery("ul.new-tabs li").removeClass("new-current");
    jQuery(".new-tab-content").removeClass("new-current");
    jQuery(this).addClass("new-current");
    jQuery("." + tab_id).addClass("new-current");
  });
});
//:: START :: LANDING FEATURED PRODUCT :: ==================
$(".product-media-main").slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: true,
  asNavFor: ".product-media--thumbs",
});
$(".product-media--thumbs").slick({
  slidesToShow: 5,
  slidesToScroll: 1,
  asNavFor: ".product-media-main",
  dots: false,
  centerMode: true,
  focusOnSelect: true,
  arrows: true,
});
//:: END :: LANDING FEATURED PRODUCT :: ==================

//:: START :: best pod for you :: ==================

jQuery(document).ready(function () {
  jQuery("ul.new-pod-tabs li").click(function () {
    var tab_id = jQuery(this).attr("data-tab");
    jQuery("ul.new-pod-tabs li").removeClass("new-pod-current");
    jQuery(".new-pod-tab-content").removeClass("new-pod-current");
    jQuery(this).addClass("new-pod-current");
    jQuery("." + tab_id).addClass("new-pod-current");
    bestpodforyou();
  });
});

//:: END :: best pod for you :: ==================

/* START -- COMPANY NUMBERS */

$(document).ready(function () {
  var counterStarted = false; // To ensure the counter runs only once
  // Function to update each counter
  function updateCounter($counter, target, duration, sign) {
    var current = 0;
    var increment = Math.ceil(target / (duration / 20)); // Increment based on duration

    function count() {
      current += increment;
      if (current >= target) {
        current = target; // Stop when reaching target
      }
      $counter.text(current.toLocaleString() + sign); // Update counter with commas
      if (current < target) {
        setTimeout(count, 20); // Adjust speed
      }
    }
    count();
  }
  // Scroll event listener to trigger counter when 'company_numbers_section' is in view
  $(window).on("scroll", function () {
    if ($(".company_numbers_section").length) {
      var sectionTop = $(".company_numbers_section").offset().top;
      var scrollTop = $(window).scrollTop();
      var windowHeight = $(window).height();
      if (scrollTop + windowHeight > sectionTop && !counterStarted) {
        counterStarted = true; // Mark counter as started to prevent multiple triggers

        // Loop through each counter element and animate it
        $(".cn_numbering_main").each(function () {
          var sign = $(this).data("sign");
          var $this = $(this).find("h3"); // Target the h3 inside
          var target = parseInt($(this).data("target")); // Get target number from data attribute
          var duration = 3000; // Duration in milliseconds (adjust as needed)
          updateCounter($this, target, duration, sign);
        });
      }
    }
  });
  // Button click to smooth scroll to the counter section
  $("#scrollToCounters").on("click", function () {
    $("html, body").animate(
      {
        scrollTop: $(".company_numbers_section").offset().top,
      },
      1000
    ); // Smooth scroll to the section
  });
});

/* END -- COMPANY NUMBERS */

/* TRUSTED REVIEWS -- START */

document.addEventListener("DOMContentLoaded", function () {
  // Play icon click event
  var playIcons = document.querySelectorAll(".tplay-icon");
  playIcons.forEach(function (playIcon) {
    playIcon.addEventListener("click", function () {
      // Pause the currently playing video
      var videoContainer = this.parentNode.querySelector(
        ".tvideo, .tyoutube-video, .tvimeo-video"
      );
      var videoElement = videoContainer.querySelector("iframe, video");
      if (videoElement && !videoElement.paused) {
        videoElement.pause();
      }
      // Hide thumbnail and play icon
      var thumbnail = this.parentNode.querySelector(".tthumbnail");
      if (thumbnail) {
        thumbnail.style.display = "none";
      }
      this.style.display = "none"; // Hide the play icon that was clicked

      // Show and play the clicked video
      if (videoContainer) {
        videoContainer.style.display = "block"; // Show the video container
        if (videoElement) {
          videoElement.play();
        }
      }
    });
  });
});

/* TRUSTED REVIEWS -- END */

/* limited sale -- START */
const totalSeconds = 24 * 60 * 60;
function formatTime(seconds) {
  const hrs = Math.floor(seconds / 3600);
  const mins = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;
  return { hrs, mins, secs };
}
function updateTimerDisplay(hrs, mins, secs) {
  document.querySelector(".sale-timer .sale-time:nth-child(1) span").innerText =
    hrs.toString().padStart(2, "0");
  document.querySelector(".sale-timer .sale-time:nth-child(3) span").innerText =
    mins.toString().padStart(2, "0");
  document.querySelector(".sale-timer .sale-time:nth-child(5) span").innerText =
    secs.toString().padStart(2, "0");

  var hours = hrs < 10 ? "0" + hrs : hrs;
  var minutes = mins < 10 ? "0" + mins : mins;
  var seconds = secs < 10 ? "0" + secs : secs;

  //document.getElementById("timer").textContent = hours + ":" + minutes + ":" + seconds;

  $(".timer_landing").html(hours + ":" + minutes + ":" + seconds);
}
function startCountdown() {
  let remainingSeconds = localStorage.getItem("timer")
    ? parseInt(localStorage.getItem("timer"))
    : totalSeconds;

  const countdownInterval = setInterval(() => {
    if (remainingSeconds <= 0) {
      remainingSeconds = totalSeconds;
    } else {
      remainingSeconds--;
    }
    localStorage.setItem("timer", remainingSeconds);

    const { hrs, mins, secs } = formatTime(remainingSeconds);
    updateTimerDisplay(hrs, mins, secs);
    
  }, 1000);
}
// Set a fixed countdown end time in UTC (24 hours from now)

function startCountdown() {
  var timeGet = jQuery('.limited-sale').find('.sale-timer').attr('data-time');
  var startMinutes = jQuery('.limited-sale').find('.sale-time[minute-time]').attr('minute-time'); // Get minutes from attribute

  let hoursToEnd = parseInt(timeGet, 10);
  let minutesToEnd = parseInt(startMinutes, 10);

  if (isNaN(hoursToEnd) || isNaN(minutesToEnd)) return; // Skip if invalid

  let saleEndTime = new Date().getTime() + (hoursToEnd * 60 + minutesToEnd) * 60 * 1000;

  function updateTimer() {
      let now = new Date().getTime();
      let timeLeft = saleEndTime - now;

      if (timeLeft > 0) {
          let hours = Math.floor(timeLeft / (1000 * 60 * 60));
          let minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
          let seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

          if (jQuery(".sale-timer").find(".sale-time").length > 0) {
            jQuery(".sale-timer").find(".sale-time").eq(0).find("span").text(hours < 10 ? "0" + hours : hours);
            jQuery(".sale-timer").find(".sale-time").eq(1).find("span").text(minutes < 10 ? "0" + minutes : minutes);
            jQuery(".sale-timer").find(".sale-time").eq(2).find("span").text(seconds < 10 ? "0" + seconds : seconds);
            
          }
          if (jQuery(".sale-timer").find(".sale-hour").length > 0){
            jQuery(".sale-timer").find(".sale-hour").find("span").text(hours < 10 ? "0" + hours : hours);
            jQuery(".sale-timer").find(".sale-minute").find("span").text(minutes < 10 ? "0" + minutes : minutes);
            jQuery(".sale-timer").find(".sale-second").find("span").text(seconds < 10 ? "0" + seconds : seconds);
          }
      } else {
        if (jQuery(".sale-timer").find(".sale-time").length > 0) {
         jQuery(".sale-timer").hide();
         clearInterval(timer);
        }
      }
  }

  updateTimer();
  let timer = setInterval(updateTimer, 1000);
}

jQuery(document).ready(function(){
  if (jQuery(".sale-timer").find(".sale-time").length > 0) {
    startCountdown();
  }
});
// let globalEndTime = new Date("2024-11-07T00:00:00Z"); // Set initial end time in UTC

// function startGlobalCountdown() {
//     function updateClock() {
//         // Get current time in UTC
//         const currentTime = new Date();

//         // Calculate the remaining time (difference between the end time and current time)
//         let remainingTime = Math.floor((globalEndTime - currentTime) / 1000);

//         // If remaining time is negative, reset it to 24 hours
//         if (remainingTime < 0) {
//             globalEndTime = new Date(currentTime.getTime() + 24 * 60 * 60 * 1000); // Add 24 hours to the current time
//             remainingTime = 24 * 3600; // Reset remaining time to 24 hours in seconds
//         }

//         // Convert remaining time into hours, minutes, and seconds
//         const hours = Math.floor(remainingTime / 3600).toString().padStart(2, '0');
//         const minutes = Math.floor((remainingTime % 3600) / 60).toString().padStart(2, '0');
//         const seconds = (remainingTime % 60).toString().padStart(2, '0');

//         // Display the countdown
//         $(".timer_landing").html(`${hours}:${minutes}:${seconds}`);
//         jQuery(".sale-timer").find(".sale-time").eq(0).find("span").text(hours);
//         jQuery(".sale-timer").find(".sale-time").eq(1).find("span").text(minutes);
//         jQuery(".sale-timer").find(".sale-time").eq(2).find("span").text(seconds);
//     }

//     // Initialize the clock and update it every second
//     updateClock(); // Initial display
//     setInterval(updateClock, 1000);
// }

// Start the countdown when the page loads
// $(document).ready(startGlobalCountdown);

// Set a fixed countdown end time in UTC (initially 12 hours from now)
let globalEndTimePro = new Date(new Date().getTime() + 12 * 60 * 60 * 1000);

function startGlobalCountdownPro() {
    function updateClock() {
        // Get current time in UTC
        const currentTime = new Date();

        // Calculate the remaining time (difference between the end time and current time)
        let remainingTime = Math.floor((globalEndTimePro - currentTime) / 1000);

        // If remaining time is negative, reset it to 12 hours
        if (remainingTime < 0) {
            globalEndTimePro = new Date(currentTime.getTime() + 12 * 60 * 60 * 1000); // Add 12 hours to the current time
            remainingTime = 12 * 3600; // Reset remaining time to 12 hours in seconds
        }

        // Convert remaining time into hours, minutes, and seconds
        let hours = Math.floor(remainingTime / 3600);
        const minutes = Math.floor((remainingTime % 3600) / 60).toString().padStart(2, '0');
        const seconds = (remainingTime % 60).toString().padStart(2, '0');

        // Convert to 12-hour format and determine AM/PM
        const period = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12 || 12; // Convert 0 to 12 for 12-hour format
        hours = hours.toString().padStart(2, '0');

        // Display the countdown with AM/PM
        $(".timer_landing_bfcm").html(`${hours}:${minutes}:${seconds}`);
        // jQuery(".sale-timer").find(".sale-time").eq(0).find("span").text(hours);
        // jQuery(".sale-timer").find(".sale-time").eq(1).find("span").text(minutes);
        // jQuery(".sale-timer").find(".sale-time").eq(2).find("span").text(seconds);
        // jQuery(".sale-timer").find(".sale-period").text(period); // Display AM/PM if you want
    }

    // Initialize the clock and update it every second
    updateClock(); // Initial display
    setInterval(updateClock, 1000);
}

// Start the countdown when the page loads
$(document).ready(startGlobalCountdownPro);


window.onload = () => {
  if ($(".sale-timer").length) {
    //updateClock();
    setInterval(function(){
      //updateClock();
    },1000);
  }
};

jQuery(document).on(
  "click",
  ".product-block-shapeselector .shapeselector-item",
  function () {
    $(".bundle--checkbox").prop("checked", false); // Uncheck by class
    $(".bundle---checkbox").prop("checked", false); // Uncheck by class
    jQuery(".product-bundle-save .rte").show();
    jQuery(".bundle--step-grid")
      .find(".bundle--step-item")
      .removeClass("active");
    $(".bundle--progress").find(".bundle--progress-fill").css("width", "0%");
  }
);

jQuery(document).on("click", ".add-landing", function (e) {
  e.preventDefault();
  var searchParams = new URLSearchParams(window.location.search);
  var variantDefaultId = jQuery(this).parent().parent().find('[name="id"]').val();
  console.log("variantDefaultId",variantDefaultId);
  if (searchParams.size == 0) {
    jQuery('[data-section="ajax-landing-feature-product"]')
      .find(".variant-option-values")
      .each(function () {
        if (jQuery(this).find('[type="radio"]:checked')) {
          jQuery(this)
            .find(".variant-feature-list.options-free:not(.has-bedgetag)")
            .each(function () {
              variantDefaultId = jQuery(this).attr("data-linked-variant");
            });
        }
      });
  } else if (searchParams.size != 0) {
    if (searchParams.get("variant") != "") {
      variantDefaultId = searchParams.get("variant");
    }
  }
  let variantArr = [];
  setTimeout(function() {
    if(jQuery('.chiller-upsell-col').find('.upsell-card.active').length>0){
      var getsectionId = '';
      jQuery('.main_feature_product.landing-fp').each(function(){
        console.log("check atttr",jQuery(this).attr('style'));
        if(jQuery(this).attr('style') == undefined || jQuery(this).attr('style') == ""){
          getsectionId = jQuery(this).attr('id');
        }
      });
      console.log("getsectionId",getsectionId);
      if(getsectionId!=""){
        if(jQuery('#'+getsectionId).find('.chiller-upsell-col').find('.upsell-card.active').attr('data-vid')!=""){
          var upsellVariantId = jQuery('#'+getsectionId).find('.chiller-upsell-col').find('.upsell-card.active').attr('data-vid');
          console.log("upsellVariantId",upsellVariantId);
          variantArr.push({
            id: upsellVariantId,
            qunatity: 1
          });
        }
      }
    }
    else{
      variantArr.push({
        id: variantDefaultId,
        qunatity: 1,
      });
    }
  
    if ($("#accesories-yes").hasClass("active")) {
      jQuery(".bundleproduct-info .bundle--checkbox:checked").each(function () {
        var variantId = jQuery(this).attr("data-vid");
        variantArr.push({
          id: variantId,
          qunatity: 1,
        });
      });
    }
    if (variantArr.length > 0) {
      $.ajax({
        url: "/cart/add.js",
        dataType: "json",
        cache: false,
        type: "post",
        data: { items: variantArr },
        success(response) {},
      });
    }
  }, 1000);
});

jQuery(document).on("change", ".bundle--checkbox", function () {
  var productCount = 0;
  var parentContainer = jQuery(this).closest(
    ".landing-selectedproduct-reverse, .landing-selectedproduct-noreverse:visible"
  );
  jQuery(this).toggleClass("active");

  var defautlPrice = jQuery("#variant__price").val();
  var newPrice = defautlPrice;
  parentContainer.find(".bundle--checkbox:checked").each(function () {
    productCount++;
    if ($("#accesories-yes").hasClass("active")) {
      var vprice = $(this).attr("data-vprice");
      newPrice = eval(vprice) + eval(newPrice);
    }
  });
  if (productCount > 0) {
    parentContainer.addClass("active");
  } else {
    parentContainer.removeClass("active");
  }

  console.log("====>");
  //var vprice = $(this).attr('data-vprice');
  //var defautlPrice = jQuery('#variant__price').val();
  //var newPrice = eval(vprice) + eval(defautlPrice);
  //jQuery('#variant__price').val(newPrice);

  $(".btn_inside_price").html(Shopify.formatMoney(newPrice));

  // Update the progress bar
  //progressbarBundle(productCount);
});

function progressbarBundle(productCount) {
  var percentageProgress = 0;
  var bundlegoal = 1;
  var bundlegoal1 = 2;
  var bundlegoal2 = 3;
  var bundlegoal3 = 4;
  var incrementProgress = parseFloat(100 / bundlegoal3);
  percentageProgress = incrementProgress * productCount;
  jQuery(".product-bundle-save .rte").show();
  jQuery(".bundle--step-grid").find(".bundle--step-item").removeClass("active");
  if (productCount == 0) {
    jQuery(".product-bundle-save .rte").find("strong").text("10% OFF");
  } else if (productCount <= bundlegoal) {
    var countProduct = bundlegoal - productCount;
    if (productCount == 1) {
      jQuery(".bundle--step-grid")
        .find(".bundle--step-item:first")
        .addClass("active");
      jQuery(".fill-progess").show();
      jQuery(".in-progess").hide();
      jQuery(".youget-offbedge").show();
    } else {
      jQuery(".fill-progess").hide();
      jQuery(".in-progess").show();
      jQuery(".count-charm-pt").text(countProduct);
      jQuery(".youget-offbedge").hide();
    }
    percentageProgress = 0;
    jQuery(".product-bundle-save .rte").find("strong").text("15% OFF");
    //jQuery('.off-text-charm').text('Free charm holder');
  } else if (productCount > bundlegoal && productCount <= bundlegoal1) {
    jQuery(".bundle--step-grid")
      .find(".bundle--step-item:first")
      .addClass("active");
    var countProduct = bundlegoal1 - productCount;
    if (productCount == 2) {
      jQuery(".bundle--step-grid")
        .find(".bundle--step-item:eq(1)")
        .addClass("active");
      jQuery(".fill-progess").show();
      jQuery(".youget-offbedge").show();
      jQuery(".in-progess").hide();
    } else {
      jQuery(".fill-progess").hide();
      jQuery(".in-progess").show();
      jQuery(".count-charm-pt").text(countProduct);
      jQuery(".youget-offbedge").hide();
    }
    percentageProgress = 35;
    jQuery(".product-bundle-save .rte").find("strong").text("20% OFF");
  } else if (productCount > bundlegoal1 && productCount <= bundlegoal2) {
    var countProduct = bundlegoal2 - productCount;
    jQuery(".bundle--step-grid")
      .find(".bundle--step-item:first")
      .addClass("active");
    jQuery(".bundle--step-grid")
      .find(".bundle--step-item:eq(1)")
      .addClass("active");
    if (productCount == 3) {
      jQuery(".bundle--step-grid")
        .find(".bundle--step-item:eq(2)")
        .addClass("active");
      jQuery(".fill-progess").show();
      jQuery(".in-progess").hide();
      jQuery(".youget-offbedge").show();
    } else {
      jQuery(".fill-progess").hide();
      jQuery(".in-progess").show();
      jQuery(".youget-offbedge").hide();
      jQuery(".count-charm-pt").text(countProduct);
    }
    percentageProgress = 70;
    jQuery(".product-bundle-save .rte").find("strong").text("25% OFF");
  } else if (productCount > bundlegoal2 && productCount <= bundlegoal3) {
    var countProduct = bundlegoal3 - productCount;
    jQuery(".bundle--step-grid")
      .find(".bundle--step-item:first")
      .addClass("active");
    jQuery(".bundle--step-grid")
      .find(".bundle--step-item:eq(1)")
      .addClass("active");
    jQuery(".bundle--step-grid")
      .find(".bundle--step-item:eq(2)")
      .addClass("active");
    if (productCount == 4) {
      jQuery(".bundle--step-grid")
        .find(".bundle--step-item:eq(3)")
        .addClass("active");
      jQuery(".fill-progess").show();
      jQuery(".in-progess").hide();
      jQuery(".youget-offbedge").show();
      //jQuery('.product-bundle-save .rte').find('strong').text('25% OFF!');
    } else {
      jQuery(".fill-progess").hide();
      jQuery(".in-progess").show();
      jQuery(".youget-offbedge").hide();
      jQuery(".count-charm-pt").text(countProduct);
    }
    //jQuery('.product-bundle-save .rte').find('strong').text('25% OFF');
    jQuery(".product-bundle-save .rte").hide();
  } else if (productCount > bundlegoal3) {
    jQuery(".sprogress-steps").find(".sprogress-item").addClass("active");
    percentageProgress = 100;
  }

  percentageProgress = Math.round(percentageProgress);
  $(".bundle--progress")
    .find(".bundle--progress-fill")
    .css("width", percentageProgress + "%");
}

jQuery(document).on("click", ".shape__product", function () {
  var url = jQuery(this).data("url");
  var pid = jQuery(this).data("pid");
  jQuery.ajax({
    url: url,
    type: "GET",
    success: function (response) {
      // Assuming the response is a JSON object containing the new HTML content
      var newContentHTML = response["ajax-landing-feature-product"];

      // Create a temporary container to parse the new HTML content
      var tempDiv = $("<div>").html(newContentHTML);
      var newContent = tempDiv.find(".pro__variant");

      if (newContent.length) {
        $(".main_feature_product").hide();
        $("#landing-featured-product-" + pid).show();

        $(".product-options-wrapper").html("");
        $("#product-options-wrapper--" + pid).html(newContent);
        var uri = window.location.href.toString();
        if (uri.indexOf("?") > 0) {
          var clean_uri = uri.substring(0, uri.indexOf("?"));
          window.history.replaceState({}, document.title, clean_uri);
        }
        var $html = $(newContentHTML);
        var $checkedRadio = $html.find('input[type="radio"]:checked');
        if ($checkedRadio.length) {
          // Find the closest label using the 'for' attribute
          var radioId = $checkedRadio.attr("id");
          var $label = $html.find('label[for="' + radioId + '"]');
          // Ensure the label exists
          if ($label.length) {
            // Get label attributes and log them
            var comparePrice = $label.attr("data-variant-cprice");
            var mainPrice = $label.attr("data-variant-price");
            if (comparePrice != undefined) {
              var percentageOff =
                ((comparePrice - mainPrice) / comparePrice) * 100;
              percentageOff = Math.round(percentageOff);
              jQuery(".landing-featured-product")
                .find(".price__container .price-save span")
                .text("save " + percentageOff + "%");
              comparePrice = Shopify.formatMoney(comparePrice);
              mainPrice = Shopify.formatMoney(mainPrice);
              jQuery(".landing-featured-product")
                .find(".price__container .price-item--regular")
                .text(comparePrice);
              jQuery(".landing-featured-product")
                .find(".price__container .price-item--sale")
                .text(mainPrice);
            
              jQuery("#variant__price").val(mainPrice);
              jQuery(".landing-featured-product")
                .find(".btn_inside_price")
                .text(mainPrice);
            }
          }
          var $labelLength = jQuery(".variant-option-values")
            .eq(0)
            .find(".variant-feature-list:not('.hide-option')").length;
          jQuery(".variant-option-values").attr(
            "label-show-count",
            $labelLength
          );
          getvarianttext();
        }
      } else {
        console.error("Could not find new content in response");
      }
    },
    error: function (xhr, status, error) {
      console.error("AJAX Error:");
    },
  });
});

/* limited sale -- END */

/* landing banner info -- video modal -- START */
$(document).ready(function () {
  $("#openModalBtn").on("click", function () {
    $("#videoModal").css("display", "flex");
    $("#modalVideo")[0].play();
  });

  $(".landing-close").on("click", function () {
    $("#videoModal").hide();
    var video = $("#modalVideo")[0];
    video.pause();
    video.currentTime = 0;
  });

  $(window).on("click", function (event) {
    if ($(event.target).is("#videoModal")) {
      $("#videoModal").css("display", "none");
      var video = $("#modalVideo")[0];
      video.pause();
      video.currentTime = 0;
    }
  });
});

$(document).ready(function () {
  $(".collasible-panel > .panel-heading").on("click", function () {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this).siblings(".panel-content").slideUp(200);
      $(".collasible-panel > .panel-heading i")
        .removeClass("fa-minus")
        .addClass("fa-plus");
    } else {
      $(".collasible-panel > .panel-heading i")
        .removeClass("fa-minus")
        .addClass("fa-plus");
      $(this).find("i").removeClass("fa-plus").addClass("fa-minus");
      $(".collasible-panel > .panel-heading").removeClass("active");
      $(this).addClass("active");
      //$(".panel-content").slideUp(200);
      $(this).siblings(".panel-content").slideDown(200);
    }
  });
});
jQuery(document).ready(function () {
  jQuery(document).on("click", ".tf_contact_btn", function () {
    var iframe = document.getElementById("chat-button");
    var iframeDocument =
      iframe.contentDocument || iframe.contentWindow.document;

    // Find the element inside the iframe and trigger a click event
    var elementToClick = iframeDocument.getElementById(
      "gorgias-chat-messenger-button"
    ); // Replace with your element's id inside iframe

    // Trigger click
    if (elementToClick) {
      elementToClick.click();
    }
  });

  jQuery(document).on("click", "#accesories-no", function () {
    jQuery(".pbd-accessories").hide();
    jQuery("#accesories-yes").removeClass("active");
    jQuery(this).addClass("active");
    var defautlPrice = jQuery("#variant__price").val();
    $(".btn_inside_price").html(Shopify.formatMoney(defautlPrice));

    $('input[name="bundle--switch"]').prop("checked", false);
  });
  jQuery(document).on("click", "#accesories-yes", function () {
    jQuery(".pbd-accessories").show();
    jQuery("#accesories-no").removeClass("active");
    jQuery(this).addClass("active");
  });
});
/* landing banner info -- video modal -- END */

// product variant height
/*
  $(document).ready(function() {
      getvarianttext();
  });
  function getvarianttext(){
      var legthArr=[];
      jQuery('.variant-feature-text').each(function() {
          var height = jQuery(this).height();
          legthArr.push(height);
      });
      var maxValue = Math.max.apply(Math,legthArr);
      jQuery('.variant-feature-text').each(function() {
          jQuery('.variant-features').css('--variant-featured-height',maxValue + 'px');
      });
  }
  $(window).on('resize', function () {
      getvarianttext();
  });
*/

$(document).ready(function () {
  getvarianttext();
  if(jQuery('.mainproduct-section').hasClass('template-water-chiller')){
    // Get the selected radio button by name
    const $selectedRadio = $('input[name="Select Chiller Type"]:checked');
    
    // Check if a radio button is selected
    if ($selectedRadio.length > 0) {
        // Get the associated label element using `for` attribute
        const $label = $(`label[for="${$selectedRadio.attr('id')}"]`);
    
        // Get the compare price inside the label
        const $comparePriceElement = $label.find('.variant-price-compareAt');
        const comparePrice = $comparePriceElement.length ? $comparePriceElement.text().trim() : null;
      
        const $priceElement = $label.find('.variant-price-onSale');
        const mainPrice = $priceElement.length ? $priceElement.text().trim() : null;
    
        console.log("Selected radio button value:", $selectedRadio.val());
        console.log("Compare price:", comparePrice);

      jQuery(".variant-feature-list[data-option-value='no']").find(".variant-priceGroup")
          .find(".variant-price-onSale")
          .text(mainPrice);
        jQuery(".variant-feature-list[data-option-value='no']").find(".variant-priceGroup")
          .find(".variant-price-compareAt")
          .text(comparePrice);
      
    } else {
        console.log("No radio button is selected.");
    }



    var regulerPrice = jQuery('.price-grid-item').find('.price__sale').find('.price-item--regular').text();
    var salePrice = jQuery('.price-grid-item').find('.price__sale').find('.price-item--sale').text();
    // jQuery(".variant-feature-list[data-option-value='no']").find(".variant-priceGroup")
    //       .find(".variant-price-onSale")
    //       .text(salePrice);
    //     jQuery(".variant-feature-list[data-option-value='no']").find(".variant-priceGroup")
    //       .find(".variant-price-compareAt")
    //       .text(regulerPrice);
  }
});

function getvarianttext() {
  var lengthArr = [];
  $(".variant-feature-text").each(function () {
    var height = $(this).height();
    lengthArr.push(height);
  });
  var maxValue = Math.max.apply(Math, lengthArr);
  $(".variant-feature-text").each(function () {
    $(".variant-features").css("--variant-featured-height", maxValue + "px");
  });
  $(".variant-feature-text").each(function () {
    var label = $(this).parent().parent().parent(".variant-feature-list");
    if (label.length && !label.hasClass("chiller-bundle-option")) {
      $(".variant-features").css(
        "--variant-featured--offheight",
        maxValue + 20 + "px"
      );
    }
  });
}
$(window).on("resize", function () {
  getvarianttext();
});
// end of product variant height

/* Best for you -- START */
$(document).ready(function () {
  bestpodforyou();
});
function bestpodforyou() {
  var legthArry = [];
  var legthArryes = [];
  jQuery(".product-image-title").each(function () {
    var height = jQuery(this).outerHeight();
    legthArry.push(height);
  });
  var maxValue = Math.max.apply(Math, legthArry);
  jQuery(".product-image-title").each(function () {
    jQuery(".tabb-static-label").css("--empty-height", maxValue + "px");
  });

  jQuery(".main-product-size .product-size").each(function () {
    var heightsize = jQuery(this).outerHeight();
    legthArryes.push(heightsize);
  });
  var maxValue = Math.max.apply(Math, legthArryes);
  jQuery(".product-image-title").each(function () {
    jQuery(".pod-tabbing-image-text").css("--psize-height", maxValue + "px");
  });
}
$(window).on("resize", function () {
  bestpodforyou();
});
/* Best for you -- end */

// pick-your-pod.liquid ========= START ======
$(document).ready(function () {
  pickyourpod();
});
function pickyourpod() {
  var legthArr = [];
  jQuery(".main-product-details > .product-details").each(function () {
    var productDetails = jQuery(this).outerHeight();
    legthArr.push(productDetails);
  });
  var maxValue = Math.max.apply(Math, legthArr);
  jQuery(".main-product-details > .product-details").each(function () {
    jQuery(".main-product-details").css("--detail-height", maxValue + "px");
  });
}
$(window).on("resize", function () {
  pickyourpod();
});

$(document).ready(function () {
  $(document).on("click", ".lh-nav-listitem", function () {
    if ($("body").hasClass("overflow-hidden-tablet")) {
      $("body").removeClass("overflow-hidden-tablet");
    }
    if ($("#Details-menu-drawer-container").hasClass("menu-opening")) {
      $("#Details-menu-drawer-container").removeAttr("open");
      $("#Details-menu-drawer-container").trigger("click");
      $("#Details-menu-drawer-container").removeClass("menu-opening");
      $(".header__icon--menu").attr("aria-expanded", false);
    }
  });
});


// NEW REVIEW SLIDER
jQuery(document).ready(function () {
  jQuery(".review-slider-allcard").slick({
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    speed: 300,
    arrows: true,
    prevArrow:
      '<button type="button" class="slick-prev"><svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 18"><path d="M10 16 2 9l8-7" stroke="#000" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"></path></svg></button>',
    nextArrow:
      '<button type="button" class="slick-next"><svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 18"><path d="m2 2 8 7-8 7" stroke="#000" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"></path></svg></button>',
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          arrows: false,
        },
      },
    ],
  });
});

var legthArr = [];
jQuery(document).ready(function () {
  jQuery(".new-review-slider-card").each(function () {
    var height = jQuery(this).height();
    legthArr.push(height);
  });
  var maxValue = Math.max.apply(Math, legthArr);
  jQuery(".new-review-slider-card").each(function () {
    jQuery(this).css("height", maxValue);
  });
});

// CUSTOM RECHARGE -- START

$('label[for="onetime-input"]').on('click', function () {
  $('label[data-option-value="single"]').click();
  $('label[for="rc-radio1"]').click();
  jQuery('.rc-radio-group__options .onetime-radio').find('[value="onetime"]').trigger("click");
});
$('label[for="subscribe-input"]').on('click', function () {
  $('label[data-option-value="single"]').click();
  $('label[for="rc-radio2"]').click();
  jQuery('.rc-radio-group__options').find('[value="subscription"]').trigger("click");
});
$('label[for="multibuy-input"]').on('click', function () {
  $('label[data-option-value="bulk-buy"]').click();
  $('label[for="rc-radio1"]').click();
});

function calculateDiscount(listPrice, salePrice) {
    if (listPrice > 0 && salePrice >= 0) {
        let discountPercentage = ((listPrice - salePrice) / listPrice) * 100;
        return discountPercentage.toFixed(2); // Returns up to 2 decimal places
    } else {
        return 0;
    }
}
/*************************** SUBSCRIPTION JS START ****************************/

jQuery(document).on("click",'[name="recharge"]',function(){
  var purchaseTypeText = $(this).parent('div').find('.buy_button_text').text();
  //console.log('purchaseTypeText',purchaseTypeText);
  var productId = jQuery('#product__id').val();
  var getSubscription = localStorage.getItem("rcProduct"+productId);
  jQuery('.purchase_option_one').find('.custom_recharge_header span').html('<b>Purchase Type:</b>'+purchaseTypeText);
  var getPlantext = '';
  var textsubid = setInterval(function(){
    //console.log("getSubscription",getSubscription);
    if(jQuery('#delivery-options option').val()==""){
      //console.log("getSubscription",getSubscription);
      if(getSubscription!=null && getSubscription!=undefined){
        var rechargeData = JSON.parse(getSubscription);
        var plansData = rechargeData.plans;
        plansData = plansData.find(item => item.charge_interval_frequency == 2);
        if(plansData!=undefined){
          jQuery('.subscribe.buy_option_btn').find('#delivery-options').show();
          getPlantext = plansData['title'];
          var planId = plansData['external_plan_id'];
          jQuery('#delivery-options option').text(getPlantext);
          jQuery('#delivery-options option').val(getPlantext);
          if(jQuery('.subscribe.buy_option_btn.active').length>0 && planId!="" && planId!=undefined){
            updateQueryString('selling_plan',planId);
          }
        }else{
          jQuery('.subscribe.buy_option_btn').find('#delivery-options').hide();
        }
        clearInterval(textsubid);
      }else{
        jQuery('.subscribe.buy_option_btn').find('#delivery-options').hide();
      }
    }
  },100);
  var url = window.location.href.split('?')[0]; // Remove query string
  var lastSegment = url.substring(url.lastIndexOf('/') + 1);
  //if(lastSegment=='chiller-maintenance-pack-bundle-bkp'){
    var ineterPriceId=setInterval(function(){
      var pricesub=0;
      var mainPrice = jQuery('.price-grid-item').find('.price-item.price-item--sale').text();
      mainPrice = mainPrice.replace('USD','');
      if(purchaseTypeText=='Subscribe & Save' && jQuery('.subscribe.buy_option_btn.active').length>0){
        pricesub = jQuery('.subscribe.buy_option_btn.active').find('.bb_sale_price.subscribe_price').text();
        pricesub=pricesub.replace(/.00/g, '');
        if(mainPrice==pricesub){
          clearInterval(ineterPriceId);
        }
        jQuery('.price-grid-item').find('.price-item.price-item--sale').text(pricesub+' USD');
      }else if(purchaseTypeText=='Single Purchase' && jQuery('.onetime.buy_option_btn.active').length>0){
        pricesub = jQuery('.onetime.buy_option_btn.active').find('.bb_sale_price').text();
        pricesub=pricesub.replace(/.00/g, '');
        if(mainPrice==pricesub){
          clearInterval(ineterPriceId);
        }
        jQuery('.price-grid-item').find('.price-item.price-item--sale').text(pricesub+' USD');
      }
    },100);
  //}
  if(jQuery('.subscribe.buy_option_btn.active').length==0){
    removeQueryParam('selling_plan');
  }
  jQuery('.product-form').find('[data-type="add-to-cart-form"]').find('#quantity').val(1);
});

// subscripiotn and save recharge option dropdown value append start js
jQuery(document).ready(function(){
  var url = window.location.href.split('?')[0]; // Remove query string
  var lastSegment = url.substring(url.lastIndexOf('/') + 1);
  if(lastSegment == 'water-maintenance-pack' || lastSegment=='chiller-maintenance-pack-bundle-bkp'){
    var productId = jQuery('#product__id').val();
    var getSubscription = localStorage.getItem("rcProduct"+productId);
    var textsubid = setInterval(function(){
      if(jQuery('#delivery-options option').val()==""){
        if(getSubscription!="" && getSubscription!=undefined){
          var rechargeData = JSON.parse(getSubscription);
          var plansData = rechargeData.plans;
          plansData = plansData.find(item => item.charge_interval_frequency == 2);
          getPlantext = plansData['title'];
          var planId = plansData['external_plan_id'];
          jQuery('#delivery-options option').text(getPlantext);
          jQuery('#delivery-options option').val(getPlantext);
          if(jQuery('.subscribe.buy_option_btn.active').length>0 && planId!="" && planId!=undefined){
            updateQueryString('selling_plan',planId);
          }
          clearInterval(textsubid);
        }
      }
    },100);
    var inSub = setInterval(function(){
      if(jQuery('.subscription-radio .rc-radio__input').length>0){
        jQuery('.rc-radio-group__options').find('.rc-radio__input').each(function(){
         if(jQuery(this).val()=='subscription'){
            var getPrice = jQuery(this).siblings('.rc-radio__label').find('.price-label').text();
            //console.log("getPrice",getPrice);
            jQuery('.bb_sale_price.subscribe_price').text(getPrice);
            clearInterval(inSub);
          }
        });
      }
    },500);
    var inSubId = setInterval(function(){
      if(jQuery('#delivery-options option').val()==""){
        if(getSubscription!="" && getSubscription!=undefined){
          var rechargeData = JSON.parse(getSubscription);
          var plansData = rechargeData.plans;
          plansData = plansData.find(item => item.charge_interval_frequency == 2);
          var planId = plansData['external_plan_id'];
          if(jQuery('.subscribe.buy_option_btn.active').length>0 && planId!="" && planId!=undefined){
            updateQueryParam('selling_plan',planId);
            jQuery('.rc-radio-group__options').find('.rc-radio__input').each(function(){
             if(jQuery(this).val()=='subscription'){
                var getPrice = jQuery(this).siblings('.rc-radio__label').find('.price-label').text();
                jQuery('.bb_sale_price.subscribe_price').text(getPrice);
              }
            });
            clearInterval(inSubId);
          }
        }
      }
    },100);
  }
});

jQuery(document).ready(function(){
  var url = window.location.href.split('?')[0]; // Remove query string
  var lastSegment = url.substring(url.lastIndexOf('/') + 1);
  if(lastSegment == 'water-maintenance-pack' || lastSegment=='chiller-maintenance-pack-bundle-bkp'){
    var productId = jQuery('#product__id').val();
    var getSubscription = localStorage.getItem("rcProduct"+productId);
    var interSubscribe = setInterval(function(){
      if(getSubscription!="" && getSubscription!=undefined){
        var rechargeData = JSON.parse(getSubscription);
        var plansData = rechargeData.plans;
        plansData = plansData.find(item => item.charge_interval_frequency == 2);
        var planId = plansData['external_plan_id'];
        if(jQuery('.subscribe.buy_option_btn.active').length>0 && planId!="" && planId!=undefined){
            updateQueryParam('selling_plan',planId);
            //clearInterval(interSubscribe);
        }
        if(lastSegment=='chiller-maintenance-pack-bundle-bkp'){
          if(plansData!=undefined){
            var variantPlanId = plansData['external_variant_ids'][0];
            if(variantPlanId!=undefined && variantPlanId!="" && rechargeData!=undefined){
              if(rechargeData.formattedVariantPrices!=undefined){
                var priceDiscount = rechargeData.formattedVariantPrices[variantPlanId]['discounted'];
                //console.log("priceDiscount",priceDiscount);
                if(priceDiscount!=undefined){
                  jQuery('.purchase_option_one').find('.subscribe.buy_option_btn').find('.bb_sale_price.subscribe_price').text(priceDiscount);
                }
              }
            }
          }
        }
      }
    },100);
  }
});

function removeQueryParam(param) {
    let url = new URL(window.location.href);
    if (url.searchParams.has(param)) {
        url.searchParams.delete(param);
        window.history.replaceState({}, "", url.toString());
    }
}

function updateQueryParam(key, value) {
    let url = new URL(window.location.href);
    url.searchParams.set(key, value);
    window.history.replaceState({}, "", url.toString());
}


function updateQueryString(key, value) {
    var url = new URL(window.location.href);
    var params = url.searchParams;
    if (params.has(key)) {
        params.set(key, value);
    } else {
        params.append(key, value);
    }
    window.history.replaceState(null, "", url.toString());
}
/*************************** SUBSCRIPTION JS END ****************************/
// subscripiotn and save recharge option dropdown value append end js

//load time price set for selected variant price subscription radio start
/*$(document).ready(function(){
  var inSub = setInterval(function(){
    if(jQuery('.subscription-radio .rc-radio__input').length>0){
      jQuery('.rc-radio-group__options').find('.rc-radio__input').each(function(){
       if(jQuery(this).val()=='subscription'){
          var getPrice = jQuery(this).siblings('.rc-radio__label').find('.price-label').text();
          var getOffText = jQuery(this).siblings('.rc-radio__label').find('.discount-label').text();
          getOffText = getOffText.replace(/[^0-9]/g,'');
          var getPlantext = jQuery('.rc-selling-plans').find('.rc-selling-plans-single').text();
          jQuery('#delivery-options option').text(getPlantext);
          jQuery('#delivery-options option').val(getPlantext);
          jQuery('.bb_sale_price.subscribe_price').text(getPrice);
          jQuery('.purchase_pack_price .subscribe_price').text(getPrice);
          var cpriceOff = jQuery('.subscribe.buy_option_btn').find('.purchase_save_price').attr('data-cprice');
          cpriceOff = parseFloat(cpriceOff/100);
          var salemainPrice = getPrice.replace(/[^0-9.]/g,'');
          var discountPercent = calculateDiscount(cpriceOff, salemainPrice);
          jQuery('.subscribe.buy_option_btn').find('.purchase_save_price').text('Save '+Math.round(discountPercent)+'%');
          
          var purchaseTypeText = $('[name="recharge"]:checked').parent('div').find('.buy_button_text').text();
          jQuery('.purchase_option_one').find('.custom_recharge_header span').html('<b>Purchase Type:</b>'+purchaseTypeText);
        }
      });
      clearInterval(inSub);
    }
  },1000);
});*/
//load time price set for selected variant price subscription radio end

// radio change for variant to price set start js
/*function subscriptionPriceSet(){
  if(jQuery('.subscription-radio .rc-radio__input').length>0){
    jQuery('.rc-radio-group__options').find('.rc-radio__input').each(function(){
     if(jQuery(this).val()=='subscription'){
        var getPrice = jQuery(this).siblings('.rc-radio__label').find('.price-label').text();
        var getOffText = jQuery(this).siblings('.rc-radio__label').find('.discount-label').text();
        getOffText = getOffText.replace(/[^0-9]/g,'');
        var getPlantext = jQuery('.rc-selling-plans').find('.rc-selling-plans-single').text();
        jQuery('#delivery-options option').text(getPlantext);
        jQuery('#delivery-options option').val(getPlantext);
        jQuery('.bb_sale_price.subscribe_price').text(getPrice);
        jQuery('.purchase_pack_price .subscribe_price').text(getPrice);
        // jQuery('.subscribe.buy_option_btn').find('.purchase_save_price').text('Save '+getOffText+'%');

        var purchaseTypeText = $('[name="recharge"]:checked').parent('div').find('.buy_button_text').text();
        jQuery('.purchase_option_one').find('.custom_recharge_header span').html('<b>Purchase Type:</b>'+purchaseTypeText);
      }
    });
  }
}*/

/*$(document).on('change', '.subscription-radio .rc-radio__input', function () {
    var subscriptionPriceHtml = $(this).siblings('.rc-radio__label').find('.price-label').html();
    $('.subscribe_price').html(subscriptionPriceHtml);
});*/
// radio change for variant to price set end js

// CUSTOM RECHARGE -- END

//RECHARGE RADIO AUTO CHECKED JS START HERE
document.addEventListener('DOMContentLoaded', function () {
  // Wait for the Recharge widget to load
  var rechargeWidgetInterval = setInterval(function () {
    var oneTimePurchaseOption = document.querySelector('.rc-radio__input');

    if (oneTimePurchaseOption) {
      // Check the "One-Time Purchase" option
      oneTimePurchaseOption.click();

      // Stop checking after setting the default
      clearInterval(rechargeWidgetInterval);
    }
  }, 100);

  // Optional: Stop trying after a certain time
  setTimeout(function () {
    clearInterval(rechargeWidgetInterval);
  }, 5000);
});
//RECHARGE RADIO AUTO CHECKED JS END HERE

// PURCHASE OPTION -- START
$(document).ready(function () {
  $(".multibuy").addClass("active");
  $(".buy_option_btn").on("click", function () {
    $(".buy_option_btn").removeClass("active");
    $(this).addClass("active");
  });
});

var QtyInput = (function () {
  var $qtyInputs = $(".qty-input");
  if (!$qtyInputs.length) {
    return;
  }
  $qtyInputs.each(function () {
    var $qtyInput = $(this);
    var $input = $qtyInput.find(".product-qty");
    var $countBtns = $qtyInput.find(".qty-count");
    var qtyMin = parseInt($input.attr("min"));
    var qtyMax = parseInt($input.attr("max"));
    // Handle input change
    $input.change(function () {
      var $this = $(this);
      var qty = parseInt($this.val());
      var $minusBtn = $qtyInput.find(".qty-count--minus");
      var $addBtn = $qtyInput.find(".qty-count--add");
      if (isNaN(qty) || qty <= qtyMin) {
        $this.val(qtyMin);
        $minusBtn.attr("disabled", true);
      } else {
        $minusBtn.attr("disabled", false);
        if (qty >= qtyMax) {
          $this.val(qtyMax);
          $addBtn.attr("disabled", true);
        } else {
          $this.val(qty);
          $addBtn.attr("disabled", false);
        }
      }
    });
    // Handle button clicks
    $countBtns.click(function () {
      var $btn = $(this);
      var operator = $btn.data("action");
      var $input = $qtyInput.find(".product-qty");
      var qty = parseInt($input.val());
      if (operator === "add") {
        qty += 1;
        if (qty >= qtyMin + 1) {
          $qtyInput.find(".qty-count--minus").attr("disabled", false);
        }
        if (qty >= qtyMax) {
          $btn.attr("disabled", true);
        }
      } else {
        qty = qty <= qtyMin ? qtyMin : qty - 1;
        if (qty === qtyMin) {
          $btn.attr("disabled", true);
        }
        if (qty < qtyMax) {
          $qtyInput.find(".qty-count--add").attr("disabled", false);
        }
      }
      $input.val(qty);
      jQuery('.product-form').find('[data-type="add-to-cart-form"]').find('#quantity').val(qty);
    });
  });
})();
// PURCHASE OPTION -- END
/********************* Products page the ice pod product Add Water Maintenance Pack? START ************************/
jQuery(document).on("change",".subscription-upsell-wrapper .selling-plan-selection",function(){
  var priceGet = jQuery(this).find('option:selected').attr('data-price');
  var pricePer = jQuery(this).find('option:selected').attr('data-per');
  var comparePrice = jQuery(this).find('option:selected').attr('data-compare-price');
  var subscription = jQuery(this).find('option:selected').attr('data-subscription');
  var sellingPlanId = jQuery(this).find('option:selected').attr('data-selling-plan-id');
  var vid = jQuery(this).find('option:selected').attr('data-vid');
  jQuery('.subscription-purchase-options [name="id"]').val(vid);
  if(subscription == 'no'){
    jQuery('[name="selling_plan"]').val('');
  }
  else{
    jQuery('[name="selling_plan"]').val(sellingPlanId);
  }
  jQuery('.subscription-upsell-wrapper .upsell-price--price').text(priceGet);
  jQuery('.subscription-upsell-wrapper .upsell-price--price-sale').html('<s>'+comparePrice+'</s>');
  jQuery('.subscription-upsell-wrapper .offer_percentage_label').text('Only '+pricePer+' per day');
});

/********************* Products page the ice pod product Add Water Maintenance Pack? END ************************/

// MOBILE VIDEO POPUP -- START

jQuery(document).ready(function($) {
    function isMobileSize() {
        return $(window).width() <= 749;
    }

    $(document).on("click",".mobile_video_btn", function () {
        if (!isMobileSize()) return; // Exit if screen size is larger than 749px

        $(".mcforms-wrapper.needsclick").hide();
        $(".product-video-block").show();
        $("body").addClass("mobile_video_active");

        let video = $(".product-video-block").find("video")[0];
        if (video) {
            video.play();
        }
    });

    function closeVideoPopup() {
        let video = $(".product-video-block").find("video")[0];
        if (video) {
            video.pause();
            video.currentTime = 0; // Reset video to the beginning
        }

        $(".product-video-block").hide();
        $("body").removeClass("mobile_video_active");
        $(".mcforms-wrapper.needsclick").show();
    }

    // Close popup when clicking on the close button
    $(".video_popup_close").on("click", function () {
        if (!isMobileSize()) return; // Exit if screen size is larger than 749px
        closeVideoPopup();
    });

    // Close popup when clicking outside the video
    $(document).on("click", function (e) {
        if (!isMobileSize()) return; // Exit if screen size is larger than 749px

        if ($(".product-video-block").is(":visible") && !$(e.target).closest(".product-video-block video, .mobile_video_btn").length) {
            closeVideoPopup();
        }
    });
});


/*
jQuery(document).ready(function(){
  jQuery(".mobile_video_btn").on("click",function () {
    $(".product-video-block").show();
    $("body").addClass("mobile_video_active");
  });
  jQuery(".video_popup_close").on("click",function () {
      //jQuery(document).on("click",".video_popup_close",function(){  
    $(".product-video-block").hide();
    $("body").removeClass("mobile_video_active");
  });
});
jQuery(document).ready(function($) {
    $('.mobile_video_btn').on('click', function() {
        $('.play-toggle').trigger('click');
    });
});
jQuery(document).ready(function($) {
    $('.video_popup_close').on('click', function() {
        $('.play-toggle').trigger('click');
    });
});
*/

// MOBILE VIDEO POPUP -- END

// QUIZ POPUP -- START
jQuery(document).ready(function(){
  jQuery(".takequiz").on("click",function () {
    $(".quiz_form_popup").show();
    $("body").addClass("quiz_popup_active");
  });
  jQuery(".quiz_form_close").on("click",function () {
    $(".quiz_form_popup").hide();
    $("body").removeClass("quiz_popup_active");
  });
});
// QUIZ POPUP -- END

// THE ICE POD PRODUCT DETAILS OUT LATEST PRODUCT SECTION ADD TO CART JS START
jQuery(document).on("click",".latest_product .latest_product_addcart",function(){
  var variantId = jQuery(this).attr('data-vid');
  var objthis = jQuery(this);
  jQuery(this).addClass('loading-custom-add');
  jQuery(objthis).find('svg').hide();
  $.ajax({
    url: "/cart/add.js",
    dataType: "json",
    cache: false,
    type: "post",
    data: { id:variantId,quantity:1},
    success(response) {
      jQuery(objthis).attr('disabled',true);
      jQuery(objthis).addClass('added-product');
      setTimeout(function(){
        jQuery(objthis).removeClass('loading-custom-add');
        jQuery(objthis).find('span').text('added');
      },2000);
    }
  });
});
$(document).on("click", ".styles_TrashButton__deleteButton__", function() {
  var flagup=0;
  setTimeout(function(){
    jQuery('.upcart-products-section .upcart-product-item').each(function(){
      var ids = jQuery(this).attr('id');
      var idsArr = ids.split(':');
      var getVariantId = jQuery('.latest_product .latest_product_btnlink').attr('data-vid');
      if(idsArr[0]==getVariantId){
        flagup=1;
      }
    });
    if(flagup==0){
      jQuery('.latest_product .latest_product_btnlink').removeAttr('disabled');
      jQuery('.latest_product .latest_product_btnlink').find('span').text('add');
      jQuery('.latest_product .latest_product_btnlink').find('svg').show();
      jQuery('.latest_product .latest_product_btnlink').removeClass('added-product');
    }
  },2000);
});
// THE ICE POD PRODUCT DETAILS OUT LATEST PRODUCT SECTION ADD TO CART JS END

// WAREHOUSE CLEARANCE PAGE FOR ADD TO CART TO REDIRECT CHECKOUT PAGE JS START
jQuery(document).ready(function(){
  var url = window.location.href.split('?')[0]; // Remove query string
  var lastSegment = url.substring(url.lastIndexOf('/') + 1);
  var queryString = window.location.search; // Gets everything after the "?" in the URL
  if(
      lastSegment == 'warehouse-clearance' || 
    lastSegment == 'warehouse-bundle' || 
    lastSegment == 'serious-about-cold-plunging' || 
    lastSegment == 'fathers-day-bundle-2025' ||
    lastSegment == 'want-to-take-cold-plunging-seriously' || 
    lastSegment == 'fathers-day-ice-pod-bundle' || 
    lastSegment == 'summer-sale'
  ){
    jQuery(document).on("click",".product-form__buttons [name='add-landing']",function(e){
      /* for blink code */
      var obj = e;
      setTimeout(function(){
      obj.preventDefault();
      },1000);
      // e.preventDefault();
      /* for blink code */
      jQuery('#CartPopup').removeClass('styles_active__');
      jQuery('.upcart-backdrop').removeClass("styles_active__");
      jQuery('body').removeClass('upcartPopupShow');
      jQuery(this).find('.loading-overlay__spinner').removeClass('hidden');
      var cInterval = setInterval(function(){
        jQuery('.upcart-backdrop').removeClass("styles_active__");
        closeCartDrawer();
      });
      setTimeout(function(){
        window.location.href='/checkout';
        //jQuery('.upcart-checkout-button').trigger("click");
      },1700)
      
    });
  }
});
function closeCartDrawer(){
  if(jQuery('body').hasClass('upcartPopupShow')){
   jQuery('body').removeClass('upcartPopupShow');
   jQuery('#UpcartPopup').removeClass('upcartPopupShow');
   jQuery('#CartPopup').removeClass("styles_active__");
   jQuery('#CartPopup').attr("data-scrollable",false);
 }
}
// WAREHOUSE CLEARANCE PAGE FOR ADD TO CART TO REDIRECT CHECKOUT PAGE JS END

// START :: Pro Chiller Upsell
  document.querySelectorAll('.upsell-card').forEach(button => {
    button.addEventListener('click', function () {
      this.closest('.upsell-col').querySelectorAll('.upsell-card').forEach(btn => {
        btn.classList.remove('active');
      });
      this.classList.add('active');
      var indexActive = this.getAttribute('data-type');
      setTimeout(function(){
        if(jQuery('.chiller-upsell-col').find('.upsell-card.active').length>0){
          var getsectionId = '';
          var z=0;
          var activeSectionId = '';
          jQuery('.main_feature_product.landing-fp').each(function(){
            if(jQuery(this).attr('style') == undefined || jQuery(this).attr('style') == ""){
              activeSectionId = jQuery(this).attr('id');
            }
            getsectionId = jQuery(this).attr('id');
          //});
          if(getsectionId!="" && getsectionId !=undefined && activeSectionId!='' && activeSectionId!=undefined){
            if(jQuery('#'+getsectionId).find('.chiller-upsell-col').find('.upsell-card').attr('data-vid')!=""){
              var upsellVariant = jQuery('#'+getsectionId).find('.chiller-upsell-col').find('.upsell-card').eq(indexActive);
              var regulerPrice = upsellVariant.attr('data-vprice');
              var comparePrice = upsellVariant.attr('data-vcprice');
              var offPrice = upsellVariant.attr('data-offprice');
              var savePer = upsellVariant.attr('data-vsave');
              console.log("getsectionId===>",regulerPrice,comparePrice)
              if(regulerPrice!=undefined && regulerPrice!="" && activeSectionId!=''){
                jQuery('#'+activeSectionId).find('.shape__product.shapeselector-item').find('.shape_product_sale').eq(z).text(regulerPrice);
              }
              if(comparePrice!=undefined && comparePrice!="" && activeSectionId!=''){
                jQuery('#'+activeSectionId).find('.shape__product.shapeselector-item').find('.shape_product_compare').eq(z).text(comparePrice);
              }
              if(offPrice!=undefined && offPrice!="" && activeSectionId!=''){
                jQuery('#'+activeSectionId).find('.shape__product.shapeselector-item').find('.shape_product_save').eq(z).text(offPrice+' off');
              }
              if(z == 0){
                jQuery('#'+activeSectionId).find('.btn_inside_price').text(regulerPrice);
                jQuery('#'+activeSectionId).find('.price-item.price-item--regular').text(comparePrice);
                jQuery('#'+activeSectionId).find('.price-item.price-item--last').text(regulerPrice);
                jQuery('#'+activeSectionId).find('.price__container').find('.price-save').find('span').text('save '+savePer+'%');
              }
            }
            z++;
          }
          else if(getsectionId!=""){
            if(jQuery('#'+getsectionId).find('.chiller-upsell-col').find('.upsell-card').attr('data-vid')!=""){
              if(indexActive==1){
                var upsellVariant = jQuery('#'+getsectionId).find('.chiller-upsell-col').find('.upsell-card').eq(1);
              }else{
                var upsellVariant = jQuery('#'+getsectionId).find('.chiller-upsell-col').find('.upsell-card').eq(0);
              }
              var regulerPrice = upsellVariant.attr('data-vprice');
              var comparePrice = upsellVariant.attr('data-vcprice');
              var offPrice = upsellVariant.attr('data-offprice');
              var savePer = upsellVariant.attr('data-vsave');
              console.log("getsectionId--->",regulerPrice,comparePrice)
              if(regulerPrice!=undefined && regulerPrice!=""){
                jQuery('.shape__product.shapeselector-item').find('.shape_product_sale').eq(3).text(regulerPrice);
              }
              if(comparePrice!=undefined && comparePrice!=""){
                jQuery('.shape__product.shapeselector-item').find('.shape_product_compare').eq(3).text(comparePrice);
              }
              if(offPrice!=undefined && offPrice!=""){
                jQuery('.shape__product.shapeselector-item').find('.shape_product_save').eq(3).text(offPrice+' off');
              }
              jQuery('#'+getsectionId).find('.btn_inside_price').text(regulerPrice);
              jQuery('#'+getsectionId).find('.s.price-item.price-item--regular').text(comparePrice);
              jQuery('#'+getsectionId).find('.s.price-item.price-item--last').text(regulerPrice);
              jQuery('#'+getsectionId).find('.price__container').find('.price-save').find('span').text('save '+savePer+'%');
            }
          }
          $('html, body').animate({
            scrollTop: $('.shopify-section.section-featured-product').offset().top
          }, 500);
         });
        }
      },500);
    });
  });
// END :: Pro Chiller Upsell

//START :: THE ICE POD PRODUCT VARIANT SELECTED SHOW MSG
jQuery(document).ready(function(){
  getselectedOption();
});
function getselectedOption(){
  var variantString='';
  if(jQuery('.product-options-wrapper .variant-grid').length>0){
    jQuery('.product-options-wrapper .variant-grid').find('[type="radio"]').each(function(){
      if(jQuery(this).is(':checked')){
        if(variantString!=""){
          variantString+='-';
        }
        variantString+=jQuery(this).attr('data-option-value');
      }
    });
  }
  var flagmsg=0;
  if(variantString!="" && variantString!=undefined){
    if(jQuery('.stock_message_atc.variant_'+variantString).length>0){
      if(jQuery('.stock_message_atc.variant_'+variantString).attr('data-atcmsg')!=""){
        var messageStock = jQuery('.stock_message_atc.variant_'+variantString).attr('data-atcmsg');
        document.querySelector(".preorder-message").style.display = "block";
        //document.querySelector(".metafield-rich_text_field").style.display = "none";
        jQuery(".preorder-message").find(".metafield-rich_text_field").hide();
        document.querySelector(".preorder-message--text").innerHTML = messageStock;
        flagmsg=1;
      }
    }
  }
  if(flagmsg==0){
    document.querySelector(".preorder-message").style.display = "none";
    document.querySelector(".preorder-message--text").innerHTML = '';
  }
}
//END :: THE ICE POD PRODUCT VARIANT SELECTED SHOW MSG